exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container{display:flex;flex-direction:column;align-items:center;padding-top:25px;text-align:center}.textContainer{width:50%}.buttonContainer{padding-top:25px}", ""]);

